import { cn } from "@/lib/utils";

const ProofStatusBadge = ({ hasProof, className = "" }) => {
  const isAvailable = Boolean(hasProof);

  return (
    <span
      title={isAvailable ? "Foto bukti tersedia" : "Foto bukti belum tersedia"}
      aria-label={isAvailable ? "Foto bukti tersedia" : "Foto bukti belum tersedia"}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        isAvailable
          ? "border-emerald-200 bg-emerald-100 text-emerald-800"
          : "border-red-200 bg-red-100 text-red-700",
        className
      )}
    >
      foto
    </span>
  );
};

export default ProofStatusBadge;
